import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20urban%20night%20scene%20with%20neon%20signs%20and%20city%20lights%2C%20abstract%20glowing%20light%20trails%2C%20deep%20red%20and%20amber%20tones%20with%20dark%20background%2C%20cinematic%20atmosphere%2C%20entertainment%20industry%20mood%2C%20editorial%20photography%20style%20with%20soft%20focus%20and%20bokeh&width=1920&height=800&seq=hero-main&orientation=landscape"
          alt="51黑料网背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-4xl leading-tight">
          <span className="block">全网爆料第一入口</span>
          <span className="block text-2xl md:text-4xl lg:text-5xl font-normal mt-2 text-background-200">实时更新今日黑料</span>
        </h1>
        <p className="text-base md:text-lg text-background-300 max-w-2xl mb-8 leading-relaxed">
          汇聚网红主播塌房视频与反差内幕，每日大赛独家猛料，24小时不停更
        </p>
        <Link
          to="/category/meiri-chigua"
          className="px-8 py-3 bg-background-50 text-foreground-900 font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap"
        >
          开始吃瓜
        </Link>
      </div>
    </section>
  );
}